var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCh = function SvgCh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15mm",
    height: "22mm",
    viewBox: "0 0 15 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#787878",
    strokeOpacity: 0.5,
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC2A2B",
    d: "M7.044 21.259Q1.537 19.119.04 12.807a1.5 1.5 0 0 1-.04-.346V1.5a1 1 0 0 1 1-1h12.764a1 1 0 0 1 1 1v11.02a1 1 0 0 1-.027.227q-1.53 6.553-7.355 8.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0EEEE",
    d: "M8.725 3.093a.5.5 0 0 1 .5.5V7.33h3.738a.5.5 0 0 1 .5.5v2.686a.5.5 0 0 1-.5.5H9.225v3.738a.5.5 0 0 1-.5.5H6.039a.5.5 0 0 1-.5-.5v-3.738H1.8a.5.5 0 0 1-.5-.5V7.83a.5.5 0 0 1 .5-.5h3.738V3.593a.5.5 0 0 1 .5-.5z"
  }))));
};
export default SvgCh;